import { createFileRoute } from "@tanstack/react-router";
import TmsForFirstResponders from "@/pages/TmsForFirstResponders";
export const Route = createFileRoute("/tms-for-first-responders")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS For First Responders | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "TMS for first responders with depression and PTSD. SAINT TMS, standard TMS, and SPRAVATO at Neuro Wellness TMS in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "TMS For First Responders | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "TMS for first responders with depression and PTSD. SAINT TMS, standard TMS, and SPRAVATO at Neuro Wellness TMS in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/tms-for-first-responders",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/tms-for-first-responders",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsForFirstResponders />;
}
